import { FPlusOverflownCodeIndicator } from '@festina-life/fplus'
import { Tooltip } from '@festina-life/ui/feedback'
import { useTranslate } from '@festina-life/ui/hooks'
import { Card, CardBody } from '@festina-life/ui/structure'

import type { TemplateReferenceValueSetupField } from '../../types/templateModel'
import { TemplateReferenceValuesTable } from './TemplateReferenceValuesTable'

type Props = {
  field: TemplateReferenceValueSetupField
  isExpanded?: boolean
}

export const TemplateReferenceValueViewer = ({ field, isExpanded }: Props) => {
  const translate = useTranslate()

  return (
    <>
      {field.value && (
        <Tooltip
          tip={
            <Card>
              <CardBody outerClassName="min-w-250">
                <TemplateReferenceValuesTable
                  field={field}
                  isExpanded={isExpanded}
                />
              </CardBody>
            </Card>
          }
          className="h-full grow"
        >
          <div className="flex size-full items-center justify-center">
            <FPlusOverflownCodeIndicator
              title={translate(
                'templateViewer.templateReferenceViewer.button.templateReferences',
              )}
            />
          </div>
        </Tooltip>
      )}
    </>
  )
}
